import React from "react";
import { Link } from "react-router-dom";

// ── Data ──────────────────────────────────────────────────────────────────────
const COLS = [
  {
    title: "Crash Course",
    links: [
      { label: "🏆 PPCA Crash Course",        path: "/training/crash-course" },
      { label: "All 50 States Study Guide",    path: "/test-ppcastudyguide" },
      { label: "Online Training Hub",          path: "/training" },
      { label: "PPCA Master Course",           path: "/training" },
      { label: "PEVO 14-State Cert",           path: "/training" },
      { label: "NY Standalone Cert",           path: "/training" },
    ],
  },
  {
    title: "Platform",
    links: [
      { label: "Marketplace",                  path: "/marketplace" },
      { label: "Load Board",                   path: "/load-board" },
      { label: "Driver Dashboard",             path: "/user-dashboard" },
      { label: "Company Dashboard",            path: "/company-dashboard" },
      { label: "Dispatcher Console",           path: "/dispatcher-dashboard" },
      { label: "Pricing Plans",                path: "/pricing" },
    ],
  },
  {
    title: "Account",
    links: [
      { label: "Sign Up Free",                 path: "/signup" },
      { label: "Driver Login",                 path: "/login" },
      { label: "Company Login",                path: "/company-login" },
      { label: "Dispatcher Login",             path: "/dispatcher-login" },
    ],
  },
];

const SOCIALS = [
  { icon: "✉",  label: "Email",   href: "mailto:info@pilotlinkusa.com" },
  { icon: "𝕏",  label: "Twitter", href: "#" },
  { icon: "💼", label: "LinkedIn", href: "#" },
  { icon: "▶",  label: "YouTube", href: "#" },
];

const BADGES = [
  "🏅 PPCA Certified",
  "🌎 All 50 States",
  "⚡ Live Load Board",
  "✅ Verified Profiles",
  "🎓 PEVO / NPCA",
  "💳 Stripe Secured",
];

const LEGAL_LINKS = [
   { label: "Copyright Policy",   path: "/copyright" },
  { label: "Privacy Policy",   path: "/privacy" },
  { label: "Terms of Service", path: "/terms" },
  { label: "Refund Policy",    path: "/refund-policy" },
  { label: "Contact Us",       path: "/contact" },
];

// ── Scroll-to-top helper — used by every footer link ─────────────────────────
function scrollTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// ── Footer link — navigates AND scrolls to top ────────────────────────────────
function FooterLink({ to, children, style, onMouseEnter, onMouseLeave }) {
  return (
    <Link
      to={to}
      onClick={scrollTop}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Link>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
export default function Footer({ isDarkMode }) {
  const D    = !!isDarkMode;
  const year = new Date().getFullYear();

  // ── Pure inline tokens — no Tailwind dark: at all ─────────────────────────
  const bg      = D ? "linear-gradient(180deg,#1a3358 0%,#0d1f3c 100%)" : "#ffffff";
  const topBdr  = D ? "#c9971c"                   : "#f59e0b";
  const text    = D ? "#f0f4f8"                   : "#0d1f3c";
  const textSub = D ? "rgba(240,244,248,0.58)"    : "#64748b";
  const linkC   = D ? "rgba(240,244,248,0.58)"    : "#64748b";
  const secHdr  = D ? "#fbbf24"                   : "#c9971c";
  const badgeBg = D ? "rgba(255,255,255,0.05)"    : "#f8fafc";
  const badgeBdr= D ? "rgba(255,255,255,0.10)"    : "#e2e8f0";
  const divC    = D ? "rgba(255,255,255,0.07)"    : "#f1f5f9";
  const discBg  = D ? "rgba(201,151,28,0.06)"     : "rgba(254,249,236,0.80)";
  const discBdr = D ? "rgba(201,151,28,0.20)"     : "#fde68a";
  const discTxt = D ? "rgba(251,191,36,0.75)"     : "rgba(120,80,10,0.80)";
  const discHdr = D ? "#fbbf24"                   : "#92400e";
  const iconBg  = D ? "rgba(255,255,255,0.07)"    : "#f1f5f9";
  const iconBdr = D ? "rgba(255,255,255,0.11)"    : "#e2e8f0";
  const iconC   = D ? "rgba(240,244,248,0.50)"    : "#94a3b8";
  const legalC  = D ? "rgba(240,244,248,0.40)"    : "#94a3b8";
  const copyC   = D ? "rgba(240,244,248,0.36)"    : "#94a3b8";
  const gold    = "#c9971c";
  const goldL   = "#f59e0b";

  return (
    <footer style={{
      background: bg,
      borderTop: `3px solid ${topBdr}`,
      fontFamily: "'Inter',system-ui,sans-serif",
      transition: "background .3s, border-color .3s",
    }}>
      <div style={{ maxWidth:1200, margin:"0 auto", padding:"clamp(40px,5vw,64px) clamp(16px,4vw,32px) clamp(24px,3vw,36px)" }}>

        {/* ── TOP GRID ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "minmax(220px,1.6fr) repeat(3,minmax(140px,1fr))",
          gap: "clamp(28px,4vw,52px)",
          marginBottom: "clamp(32px,4vw,48px)",
        }}
          // Responsive: on small screens collapse to 2 cols, then 1
          className="footer-grid"
        >
          {/* ── Brand column ── */}
          <div>
            {/* Logo */}
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
              <div style={{
                width:44, height:44, borderRadius:12,
                background: `linear-gradient(135deg,${gold},${goldL})`,
                display:"flex", alignItems:"center", justifyContent:"center",
                fontWeight:900, fontSize:22, color:"#0d1f3c",
                boxShadow: `0 4px 14px rgba(201,151,28,0.38)`, flexShrink:0,
              }}>P</div>
              <span style={{ fontSize:20, fontWeight:900, letterSpacing:"-.02em", color:text }}>
                Pilot<span style={{ color:gold }}>Link</span>
                <span style={{ fontSize:11, fontWeight:700, color:textSub, marginLeft:4, letterSpacing:".06em" }}>USA</span>
              </span>
            </div>

            <p style={{ fontSize:13.5, color:textSub, lineHeight:1.78, maxWidth:280, marginBottom:20 }}>
              The #1 platform for pilot car professionals — certification training, verified load board, and tools to grow your career across all 50 states.
            </p>

            {/* CTA */}
            <FooterLink
              to="/training/crash-course"
              style={{
                display: "inline-flex", alignItems:"center", gap:7,
                background: `linear-gradient(135deg,${gold},${goldL})`,
                color:"#0d1f3c", fontSize:12, fontWeight:800,
                padding:"9px 18px", borderRadius:99, textDecoration:"none",
                boxShadow: `0 3px 12px rgba(201,151,28,0.38)`,
                marginBottom:20, transition:"filter .15s",
              }}
              onMouseEnter={e => e.currentTarget.style.filter="brightness(1.08)"}
              onMouseLeave={e => e.currentTarget.style.filter="none"}
            >
              🏆 Get PPCA Certified
            </FooterLink>

            {/* Socials */}
            <div style={{ display:"flex", gap:8 }}>
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} aria-label={s.label}
                  style={{
                    width:36, height:36, borderRadius:9,
                    display:"flex", alignItems:"center", justifyContent:"center",
                    fontSize:14, background:iconBg, border:`1px solid ${iconBdr}`,
                    color:iconC, textDecoration:"none", transition:"all .15s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor=gold; e.currentTarget.style.color=gold; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor=iconBdr; e.currentTarget.style.color=iconC; }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Link columns ── */}
          {COLS.map(col => (
            <div key={col.title}>
              <h3 style={{
                fontSize:10, fontWeight:800, color:secHdr,
                letterSpacing:".14em", textTransform:"uppercase", marginBottom:16,
              }}>
                {col.title}
              </h3>
              <ul style={{ listStyle:"none", margin:0, padding:0, display:"flex", flexDirection:"column", gap:11 }}>
                {col.links.map(l => (
                  <li key={l.label}>
                    <FooterLink
                      to={l.path}
                      style={{ fontSize:13.5, fontWeight:500, color:linkC, textDecoration:"none", transition:"color .13s" }}
                      onMouseEnter={e => e.currentTarget.style.color=goldL}
                      onMouseLeave={e => e.currentTarget.style.color=linkC}
                    >
                      {l.label}
                    </FooterLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ── TRUST BADGES ── */}
        <div style={{
          display:"flex", flexWrap:"wrap", justifyContent:"center", gap:8,
          padding:"clamp(14px,2vw,20px) 0", marginBottom:"clamp(16px,2vw,24px)",
          borderTop:`1px solid ${divC}`, borderBottom:`1px solid ${divC}`,
        }}>
          {BADGES.map(b => (
            <span key={b} style={{
              fontSize:11.5, fontWeight:600, color:textSub,
              display:"flex", alignItems:"center", gap:5,
              background:badgeBg, border:`1px solid ${badgeBdr}`,
              padding:"6px 12px", borderRadius:99,
            }}>{b}</span>
          ))}
        </div>

        {/* ── DISCLAIMER ── */}
        <div style={{
          background:discBg, border:`1px solid ${discBdr}`,
          borderRadius:13, padding:"clamp(12px,1.5vw,16px) clamp(14px,2vw,20px)",
          marginBottom:"clamp(16px,2vw,24px)",
        }}>
          <p style={{ fontSize:12, lineHeight:1.78, color:discTxt, margin:0 }}>
            <strong style={{ color:discHdr, marginRight:5 }}>📋 Please note:</strong>
            PilotLink USA prepares you for state pilot car certification exams — we do not issue the official cert (your state DOT does). All payments processed securely by Stripe. Marketplace transactions are between users directly — inspect before you buy. Always confirm current regulations with your state permit office before any permitted move.
          </p>
        </div>

        {/* ── BOTTOM BAR ── */}
        <div style={{
          paddingTop:"clamp(14px,2vw,20px)", borderTop:`1px solid ${divC}`,
          display:"flex", flexWrap:"wrap", justifyContent:"space-between",
          alignItems:"center", gap:12,
        }}>
          <p style={{ fontSize:12.5, color:copyC, margin:0 }}>
            © {year} PilotLink USA · Built for oversize load professionals.
          </p>

          {/* Legal links — scroll to top on click */}
          <div style={{ display:"flex", flexWrap:"wrap", justifyContent:"center", gap:"clamp(10px,2vw,20px)" }}>
            {LEGAL_LINKS.map(l => (
              <FooterLink
                key={l.label}
                to={l.path}
                style={{ fontSize:12.5, color:legalC, textDecoration:"none", fontWeight:500, transition:"color .13s" }}
                onMouseEnter={e => e.currentTarget.style.color=D?"rgba(240,244,248,0.80)":"#334155"}
                onMouseLeave={e => e.currentTarget.style.color=legalC}
              >
                {l.label}
              </FooterLink>
            ))}
          </div>
        </div>

      </div>

      {/* ── Responsive grid CSS ── */}
      <style>{`
        @media (max-width:1023px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width:599px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}
